import clsx from 'clsx';
import { useState } from 'react';
import Tab from 'components/tab';
import styles from './styles.module.scss';

export type TabProp = { title: string; content: React.ReactNode };

export type TabsProps = {
  tabs: TabProp[];
  onTabChange?: (i: number) => void;
  tabsContainerClassName?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  defaultTab?: number;
};

const Tabs: React.FC<TabsProps> = (props) => {
  const {
    tabs,
    onTabChange,
    contentClassName,
    tabsContainerClassName,
    children,
    defaultTab = 0,
  } = props;

  const [selectedTab, setSelectedTab] = useState(defaultTab);

  const handleSelectTab = (i: number) => () => {
    setSelectedTab(i);
    onTabChange?.(i);
  };

  return (
    <>
      <div className={clsx(styles.tabs, tabsContainerClassName)}>
        {tabs.map((tab, index) => <Tab key={index} onClick={handleSelectTab(index)} title={tab.title} selected={selectedTab === index} />)}
      </div>

      <div className={contentClassName}>
        {tabs[selectedTab].content}
        {children}
      </div>
    </>
  );
};

export default Tabs;
